import { type QueryOptions, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { Me } from "@unbox/api";
import { handleError } from "@/api/error";
import { client } from "./client";

export const useMe = (options: QueryOptions<Me | null> = {}) => {
  return useQuery({
    ...options,
    queryKey: ["me"],
    queryFn: async () => {
      const res = await client.user.me.$get({});
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};

export const useUpdateMe = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (json: { firstName: string; lastName: string }) => {
      const res = await client.user.me.$put({ json });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["me"] }),
  });
};
